<template>
  <!-- -->
  <list-page>
    <list-table background-color="#FFF">
      <div class="mini-setting">
        <div class="left">
          <div
              class="component-item"
              v-for="(item, idx) in componentList"
              :key="'left-' + idx"
              draggable="true"
              @dragstart="handleDragStart($event, item)"
              @dragend="handleDragEnd"
          >
            <yq-icon class="icon" :name="item.icon"/>
            <div class="name">{{item.label}}</div>
          </div>
        </div>
        <div class="center">
          <yq-icon name="24gf-gear" class="setting-icon" @click="toSetPageInfo"/>
          <yq-icon name="element-ui_document" class="setting-icon document" @click="showDocument = true"/>
          <div class="view-area">
            <div class="content">
              <img alt="" class="content-bg" src="../../../../../../assets/image/mini/iphone-4.png"/>
              <div class="content-navigation" :style="{'color': pageSetting.pageInfo.navigationColor, 'background-color': pageSetting.pageInfo.navigationBackground, 'background-image': `url(${getImageUrl(pageSetting.pageInfo.navigationBackImage)})`, 'background-repeat': 'no-repeat','background-size': 'cover'}">
                {{pageSetting.pageInfo.navigationName}}
              </div>
              <img alt="" class="content-bg-time" src="../../../../../../assets/image/mini/iphone-time.png"/>
              <img alt="" class="content-bg-wifi" src="../../../../../../assets/image/mini/iphone-wifi.png"/>
              <div
                  class="content-area"
                  @dragover.prevent="handleDragOver"
                  @dragenter="handleDragEnter"
                  @dragleave="handleDragLeave"
                  @drop="handleDrop"
              >
                <component :is="`${item.componentName}Show`"
                    :data="item"
                    :style="{'margin': item.componentMargin, 'background-color': item.componentBackground, 'background-image': `url(${getImageUrl(item.componentBackgroundImage)})`, 'background-repeat': 'no-repeat','background-size': 'cover', 'border-radius': `${item.radius}px`}"
                    v-for="(item, idx) in pageSetting.dataList"
                    :key="'data-' + idx"
                    class="mini-program-component"
                    :class="idx === currentIndex? 'active': ''"
                    draggable="true"
                    @dragstart="handleComponentDragStart($event, idx)"
                    @dragover.prevent.stop="handleComponentDragOver($event, idx)"
                    @dragenter.prevent.stop="handleComponentDragEnter($event, idx)"
                    @dragend="handleComponentDragEnd"
                    @drop.stop="handleComponentDrop($event, idx)"
                    @click="selectComponent(item, idx)"
                >
<!--                  <component :is="`${item.componentName}Show`" :data="item" :style="{'margin': item.componentMargin, 'background-color': item.componentBackground, 'background-image': `url(${getImageUrl(item.componentBackgroundImage)})`, 'background-repeat': 'no-repeat','background-size': 'cover'}"/>-->
                </component>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="currentComponent" class="setting-area">
            <div class="label-name">{{currentComponent.label}}</div>
            <div class="label-desc">{{currentComponent.componentName}}</div>
            <div class="remove">
              <table-button @click="showComponentSetting = true">
                <yq-icon name="24gf-gear" />
              </table-button>
              <table-button @click="removeCurrent" message="是否确认删除当前组件？" el-type="danger">
                <yq-icon name="element-ui_delete" />
              </table-button>
            </div>
            <component :is="`${currentComponent.componentName}Setting`" :data="currentComponent" @change="changeDataSetting" />
          </div>
        </div>
      </div>
    </list-table>
    <form-page :show-page="false">
      <page-button el-type="danger" @click="clearAll">清空</page-button>
      <page-button el-type="primary" @click="toSaveSetting">保存</page-button>
    </form-page>
    <el-dialog v-model="showComponentSetting" dialog-width="1" title="组件设置">
      <form-items label-width="2.4rem" :columns="1">
        <form-item label="上边距">
          <el-input v-model="currentComponent.marginTop" placeholder="请输入上边距"/>
        </form-item>
        <form-item label="左右边距">
          <el-input v-model="currentComponent.marginLeft" placeholder="请输入左右边距，默认30"/>
        </form-item>
        <form-item label="圆角角度">
          <el-input v-model="currentComponent.radius" placeholder="请输入圆角角度，一般为10"/>
        </form-item>
        <form-item label="高度" v-if="currentComponent.heightAble">
          <el-input v-model="currentComponent.height" placeholder="请输入高度"/>
        </form-item>
        <form-item label="背景颜色" v-if="currentComponent.bgColorAble !== false">
          <el-color-picker v-model="currentComponent.componentBackground" show-alpha/>
        </form-item>
        <form-item label="背景图片" v-if="currentComponent.bgImgAble !== false">
          <image-upload v-model="currentComponent.componentBackgroundImage" folder="miniSetting" :limit="1" :accept="'image/*'" :show-folder-manage="true"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showComponentSetting = false">取消</page-button>
        <page-button @click="updateCurrentMargin" el-type="primary">确定</page-button>
      </template>
    </el-dialog>
    <el-dialog v-model="showPageInfoDialog" dialog-width="2" title="页面设置">
      <form-items label-width="2.4rem" :columns="1">
        <form-item label="页面名称">
          <el-input v-model="pageSetting.pageInfo.navigationName" placeholder="请输入页面名称"/>
        </form-item>
        <form-item label="文本颜色">
          <el-color-picker v-model="pageSetting.pageInfo.navigationColor" show-alpha/>
        </form-item>
        <form-item label="背景颜色">
          <el-color-picker v-model="pageSetting.pageInfo.navigationBackground" show-alpha/>
        </form-item>
        <form-item label="背景图片">
          <image-upload v-model="pageSetting.pageInfo.navigationBackImage" folder="miniSetting" :limit="1" :accept="'image/*'" :show-folder-manage="true"/>
        </form-item>
        <form-item label="闪屏广告" v-if="pageName === 'home'" >
          <image-upload v-model="pageSetting.pageInfo.splashImage" folder="miniSetting" :limit="5" :accept="'image/*'" :show-folder-manage="true"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showPageInfoDialog = false" el-type="primary">确定</page-button>
      </template>
    </el-dialog>
    <el-dialog v-model="showDocument" title="配置文件说明" dialog-width="2">
      <div style="white-space: pre-wrap">
      1 所有组件都可以添加背景图片，但添加背景图片时需要考虑组件本身的尺寸。上传图片时没有强制的尺寸要求，但各组件对图片的兼容性不同，可能导致变形，请参考组件尺寸进行背景图片调整。<br/>
      2 所有功能跳转页面，都可以自定义路由，直接修改路由即可，但路由的准确性需要自行确认。<br/>
      3 跳转商品列表页时可带参数，如果要跳转到指定的分类下，添加category=xxx的参数，分类编码以商品管理为准。<br/>
      4 跳转小程序信息、商品详情时，参数为id=xxx<br/>
      </div>
      <template #footer>
        <page-button @click="showDocument = false" el-type="primary">确认</page-button>
      </template>
    </el-dialog>
  </list-page>

</template>

<script>


import YqIcon from "@/components/YqIcon.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";

import BannerSetting from "@/views/h5/common/sys/miniProgram/setting/component/BannerSetting.vue";
import BannerShow from "@/views/h5/common/sys/miniProgram/setting/component/BannerShow.vue";
import CategoryTree2IconShow from "@/views/h5/common/sys/miniProgram/setting/component/CategoryTree2IconShow.vue";
import CategoryTree2ImageShow from "@/views/h5/common/sys/miniProgram/setting/component/CategoryTree2ImageShow.vue";
import ImageDataShow from "@/views/h5/common/sys/miniProgram/setting/component/ImageDataShow.vue";
import ProductHotListShow from "@/views/h5/common/sys/miniProgram/setting/component/ProductHotListShow.vue";
import ProductSearchShow from "@/views/h5/common/sys/miniProgram/setting/component/ProductSearchShow.vue";
import TableData2Show from "@/views/h5/common/sys/miniProgram/setting/component/TableData2Show.vue";
import TableData3Show from "@/views/h5/common/sys/miniProgram/setting/component/TableData3Show.vue";
import TableData4Show from "@/views/h5/common/sys/miniProgram/setting/component/TableData4Show.vue";
import TableGridShow from "@/views/h5/common/sys/miniProgram/setting/component/TableGridShow.vue";
import CategoryTree2ImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/CategoryTree2ImageSetting.vue";
import CategoryTree2IconSetting from "@/views/h5/common/sys/miniProgram/setting/component/CategoryTree2IconSetting.vue";
import TableData2Setting from "@/views/h5/common/sys/miniProgram/setting/component/TableData2Setting.vue";
import ProductHotListSetting from "@/views/h5/common/sys/miniProgram/setting/component/ProductHotListSetting.vue";
import ProductSearchSetting from "@/views/h5/common/sys/miniProgram/setting/component/ProductSearchSetting.vue";
import TableGridSetting from "@/views/h5/common/sys/miniProgram/setting/component/TableGridSetting.vue";
import TableData3Setting from "@/views/h5/common/sys/miniProgram/setting/component/TableData3Setting.vue";
import TableData4Setting from "@/views/h5/common/sys/miniProgram/setting/component/TableData4Setting.vue";
import ImageDataSetting from "@/views/h5/common/sys/miniProgram/setting/component/ImageDataSetting.vue";
import ComponentTextSetting from "@/views/h5/common/sys/miniProgram/setting/component/ComponentTextSetting.vue";
import ComponentTextShow from "@/views/h5/common/sys/miniProgram/setting/component/ComponentTextShow.vue";
import ScrollWidthShow from "@/views/h5/common/sys/miniProgram/setting/component/ScrollWidthShow.vue";
import ScrollWidthSetting from "@/views/h5/common/sys/miniProgram/setting/component/ScrollWidthSetting.vue";
import ProductCategorySetting from "@/views/h5/common/sys/miniProgram/setting/component/ProductCategorySetting.vue";
import ProductCategoryShow from "@/views/h5/common/sys/miniProgram/setting/component/ProductCategoryShow.vue";
import UserProfileSetting from "@/views/h5/common/sys/miniProgram/setting/component/UserProfileSetting.vue";
import UserProfileShow from "@/views/h5/common/sys/miniProgram/setting/component/UserProfileShow.vue";
import UserExitSetting from "@/views/h5/common/sys/miniProgram/setting/component/UserExitSetting.vue";
import UserExitShow from "@/views/h5/common/sys/miniProgram/setting/component/UserExitShow.vue";
import SaleOrderSetting from "@/views/h5/common/sys/miniProgram/setting/component/SaleOrderSetting.vue";
import SaleOrderShow from "@/views/h5/common/sys/miniProgram/setting/component/SaleOrderShow.vue";
import MemberServiceSetting from "@/views/h5/common/sys/miniProgram/setting/component/MemberServiceSetting.vue";
import MemberServiceShow from "@/views/h5/common/sys/miniProgram/setting/component/MemberServiceShow.vue";
import MemberCardSetting from "@/views/h5/common/sys/miniProgram/setting/component/MemberCardSetting.vue";
import MemberCardShow from "@/views/h5/common/sys/miniProgram/setting/component/MemberCardShow.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import ImageUtil from "@/util/imageUtil";
import miniProgramSettingApi from "@/api/normal/sys/miniProgramSettingApi";


export default {
  props: {
    navigationName: {default: "小程序商城"},
    pageName: {default: ""}, // 哪个页面，用于向后端请求数据
    componentList: { // 这个页面支持哪些组件
      default: () => []
    }
  },
  name: "",
  components: {
    ImageUpload, TableButton, UserExitSetting, UserExitShow, SaleOrderSetting, SaleOrderShow, MemberServiceSetting, MemberServiceShow, MemberCardSetting, MemberCardShow,
    YqIcon, FormTag, BannerSetting, BannerShow, CategoryTree2IconShow, CategoryTree2ImageShow, ImageDataShow, ProductHotListShow, ProductSearchShow, TableData2Show, TableData3Show, TableData4Show, TableGridShow,
    CategoryTree2ImageSetting, CategoryTree2IconSetting, TableData2Setting, ProductHotListSetting, ProductSearchSetting, TableGridSetting, TableData3Setting, TableData4Setting, ImageDataSetting,
    ListTable, ListPage, FormPage, FormItems, FormItem, ComponentTextSetting, ComponentTextShow, ScrollWidthSetting, ScrollWidthShow, ProductCategorySetting, ProductCategoryShow, UserProfileSetting, UserProfileShow,
  },
  data() {
    return {
      draggedItem: null,
      draggedIndex: null,
      currentComponent: null,
      currentIndex: -1, // 编辑的组件序号
      showComponentSetting: false, // 是否显示组件设置弹窗
      showPageInfoDialog: false,
      pageSetting: {
        pageInfo: {// 页面整体样式
          navigationColor: "",
          navigationBackground: "",
          navigationBackImage: "",
          splashImage: "",
        },
        dataList: [], // 添加到页面的组件
      },
      showDocument: false, // 显示配置的文档
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 向数据库查询
      miniProgramSettingApi.findSetting(this.pageName).then(res => {
        if (!res || !res.id) {
          // 数据库中不存在数据，创建一个新的
          this.pageSetting = {
            pageName: this.pageName,
            pageInfo: {// 页面整体样式
              navigationName: this.navigationName,
            },
            dataList: [], // 添加到页面的组件
          }
        } else { // 数据已存在，将数据库中的数据，显示到页面
          let jsonResult = JSON.parse(res.pageSetting);
          this.pageSetting = {
            ...res,
            pageInfo: jsonResult.pageInfo,
            dataList: jsonResult.dataList,
          }
        }
      });
    },
    // 获取图片的url
    getImageUrl(url) {
      return ImageUtil.getFileUrlSingle(url);
    },
    // 选中某个组件
    selectComponent(data, idx) {
      this.currentComponent = data;
      this.currentIndex = idx;
    },
    removeCurrent() {
      this.pageSetting.dataList.splice(this.currentIndex, 1);
      this.currentIndex = -1;
      this.currentComponent = null;
    },
    handleDragStart(event, item) {
      this.draggedItem = item;
      this.draggedIndex = null;
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setData('application/json', JSON.stringify(item));
      event.dataTransfer.setData('source', 'left');

      setTimeout(() => {
        event.target.classList.add('dragging');
      }, 0);
    },

    handleDragEnd(event) {
      event.target.classList.remove('dragging');
      this.draggedItem = null;
      this.draggedIndex = null;
    },

    handleDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
    },

    handleDragEnter(event) {
      event.currentTarget.classList.add('drag-over');
    },

    handleDragLeave(event) {
      event.currentTarget.classList.remove('drag-over');
    },

    handleDrop(event) {
      event.preventDefault();
      event.currentTarget.classList.remove('drag-over');

      const source = event.dataTransfer.getData('source');

      if (source === 'left') {
        const data = event.dataTransfer.getData('application/json');
        if (data) {
          const item = JSON.parse(data);

          const rect = event.currentTarget.getBoundingClientRect();
          const x = event.clientX - rect.left;
          const y = event.clientY - rect.top;
          console.log(x, y)
          this.addData2List(item);
        }
      }
    },

    handleComponentDragStart(event, index) {
      console.log('开始拖拽组件，索引:', index);
      this.draggedIndex = index;
      this.draggedItem = null;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('source', 'center');
      event.dataTransfer.setData('index', index.toString());

      event.stopPropagation();

      setTimeout(() => {
        event.target.classList.add('component-dragging');
      }, 0);
    },

    handleComponentDragOver(event, index) {
      if (this.draggedIndex !== null && this.draggedIndex !== index) {
        event.dataTransfer.dropEffect = 'move';
      }
    },

    handleComponentDragEnter(event, index) {
      if (this.draggedIndex !== null && this.draggedIndex !== index) {
        event.target.classList.add('component-drag-over');
      }
    },

    handleComponentDragEnd(event) {
      console.log('拖拽结束');
      event.target.classList.remove('component-dragging');
      document.querySelectorAll('.component-drag-over').forEach(el => {
        el.classList.remove('component-drag-over');
      });
      this.draggedIndex = null;
      this.draggedItem = null;
    },

    handleComponentDrop(event, targetIndex) {
      console.log('放置到索引:', targetIndex, '拖拽索引:', this.draggedIndex);
      event.preventDefault();
      event.stopPropagation();
      const source = event.dataTransfer.getData('source');

      if (source === 'center' && this.draggedIndex !== null) {
        const sourceIndex = this.draggedIndex;

        if (sourceIndex !== targetIndex) {
          this.reorderList(sourceIndex, targetIndex);
        }
      } else if (source === 'left') {
        // 从左侧拖过来，将元素添加到dataList对应的序号
        this.addData2List(this.draggedItem, targetIndex);
      }
      event.target.classList.remove('component-drag-over');
    },

    reorderList(fromIndex, toIndex) {
      console.log('重新排序:', fromIndex, '->', toIndex);
      const item = this.pageSetting.dataList.splice(fromIndex, 1)[0];
      this.pageSetting.dataList.splice(toIndex, 0, item);

      console.log('排序后的列表:', this.pageSetting.dataList);
    },
    // 将数据添加到dataList列表
    addData2List(component, index) {
      let isFirst = ((index === null || index === undefined) && this.pageSetting.dataList.length === 0) || index === 0;
      let com = {
        ...component,
        componentMargin: isFirst? "0 30px" : "30px 30px 0 30px",
        marginTop: isFirst? 0 : 30,
        marginLeft: 30,
        componentBackground: "#FFF",
      }
      if (index === null || index === undefined) { // 添加到末尾
        this.pageSetting.dataList.push(com);
      } else {
        this.pageSetting.dataList = [
          ...this.pageSetting.dataList.slice(0, index),
          com,
          ...this.pageSetting.dataList.slice(index, this.pageSetting.dataList.length)
        ];
      }
    },
    // 组件的设置信息发生变更
    changeDataSetting(data) {
      this.currentComponent = data;
      this.pageSetting.dataList[this.currentIndex] = data;
    },
    // 更新组件的margin
    updateCurrentMargin() {
      this.currentComponent.componentMargin = `${this.currentComponent.marginTop}px ${this.currentComponent.marginLeft}px 0 ${this.currentComponent.marginLeft}px`;
      this.changeDataSetting(this.currentComponent);
      this.showComponentSetting = false;
    },
    toSetPageInfo() {
      this.showPageInfoDialog = true;
    },
    // 保存页面配置数据
    toSaveSetting() {
      // 将页面的设置，整合成json对象，用于转换字符串储存
      let jsonStr = {
        pageInfo: this.pageSetting.pageInfo,
        dataList: this.pageSetting.dataList,
      }
      // 整理对象结果
      let data = {
        ...this.pageSetting,
        pageSetting: JSON.stringify(jsonStr),
      }
      miniProgramSettingApi.saveSetting(data).then(() => {
        this.init();
      })
    },
    clearAll() {
      this.pageSetting.dataList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.mini-setting{
  display: flex;
  justify-content: space-between;
  height: 100%;
  .left{
    width: 280px;
    background: var(--yq-background-color);
    height: 100%;
    overflow: auto;
    .component-item{
      display: inline-block;
      width: 80px;
      aspect-ratio: 1/1;
      background: #FFF;
      margin-left: 10px;
      margin-top: 10px;
      box-sizing: border-box;
      padding-top: 10px;
      cursor: move;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &.dragging {
        opacity: 0.5;
        transform: scale(0.95);
      }

      .icon{
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 38px;
      }
      .name{
        text-align: center;
        font-size: var(--yq-font-size-small);
      }
    }
  }
  .center{
    flex: 1;
    width: 100px;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .setting-icon{
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      z-index: 99;
      color: var(--el-color-primary);
      &.document{
        right: 50px
      }
    }

    .view-area{
      width: 750px;
      height: 1800px;
      position: relative;
      scale: .4;
      .image-bg{
        width: 100%;
      }
      .content{
        position: absolute;
        left: 40px;
        top: 0;
        width: 750px;
        height: 1620px;
        box-sizing: content-box;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: 35px 40px 35px;
        .content-bg{
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          pointer-events: none;
        }
        .content-bg-time{
          position: absolute;
          width: 90px;
          top: 60px;
          left: 70px;
          z-index: 99;
        }
        .content-bg-wifi{
          position: absolute;
          width: 150px;
          top: 55px;
          right: 55px;
          z-index: 99;
        }
        .content-navigation{
          position: absolute;
          left: 2%;
          font-size: 0.8rem;
          top: 0;
          font-weight: 600;
          z-index: 1;
          width: 96%;
          height: 190px;
          border-radius: 120px 120px 0 0;
          display: flex;
          justify-content: center;
          padding-top: 120px;
          box-sizing: border-box;
        }
        .content-area{
          height: 100%;
          width: 100%;
          border-radius: 100px;
          overflow: auto;
          font-size: 38px;
          position: relative;
          transition: all 0.3s ease;
          background-color: var(--yq-background-color);
          box-sizing: border-box;
          padding-bottom: 500px;
          padding-top: 160px;
          &.drag-over {
            background-color: rgba(64, 158, 255, 0.1);
            border: 2px dashed #409EFF;
            box-shadow: inset 0 0 20px rgba(64, 158, 255, 0.2);
          }

          .mini-program-component {
            cursor: move;
            transition: all 0.3s ease;
            position: relative;
            user-select: none;
            box-sizing: border-box;
            &.active{
              border: 3px solid var(--el-color-danger);
            }
            &:hover {
              outline: 2px solid #409EFF;
              outline-offset: 2px;
            }

            &.component-dragging {
              opacity: 0.5;
              transform: scale(0.98);
            }

            &.component-drag-over {
              border-top: 3px solid #409EFF;

              &::before {
                content: '';
                position: absolute;
                top: -3px;
                left: 0;
                right: 0;
                height: 3px;
                background: #409EFF;
                z-index: 10;
              }
            }

          }
        }
      }
    }
  }
  .right {
    width: 400px;
    height: 100%;
    overflow: auto;
    background: var(--yq-background-color);
    padding: 10px;
    box-sizing: border-box;
    .setting-area{
      background-color: #FFF;
      box-sizing: border-box;
      height: 100%;
      display: flex;
      overflow: hidden;
      flex-direction: column;
      padding-top: 20px;
      position: relative;
      .label-name{
        font-size: var(--yq-font-size-large);
        font-weight: 600;
        padding: 0 20px;
      }
      .label-desc{
        color: var(--yq-font-color-desc);
        opacity: .5;
        margin-bottom: 10px;
        padding: 0 20px;
      }
      .remove{
        position: absolute;
        right: 20px;
        top: 20px;
        color: var(--el-color-danger);
      }
    }
  }
}
// 下层组件样式
.mini-setting{
  .center{
    :deep(.mini-component-show) { // show组件样式
      background-color: #FFF;
    }
  }
  .right{
    :deep(.mini-component) { // setting组件样式
      flex: 1;
      padding: 0 20px 20px;
      overflow: auto;
    }
  }
}

</style>